import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const AgentList = Loadable(lazy(() => import('./AgentsList')));

const AgentsRoutes = [
	{
		path: '/agent/list',
		element: <AgentList />,
		auth: authRoles.admin,
	},
];

export default AgentsRoutes;
